import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import axios, { AxiosError } from "axios";
import { TokenResponse } from "../models/General";
import { insertUrlParam } from "./Utilities";

const idpByLayer: Record<string, string> = {
  experience: "Okta",
  process: "Microsoft",
  outbound: "Microsoft",
};

export const acquireAccessTokenInteractive = async (
  instance: IPublicClientApplication,
  account: AccountInfo
) => {
  const request = {
    scopes: [process.env.REACT_APP_SCOPE!],
    account: account,
  };

  const { accessToken } = await (async () => {
    try {
      return await instance.acquireTokenSilent(request);
    } catch (error) {
      return await instance.acquireTokenPopup(request);
    }
  })();

  return accessToken;
};

export const requestToken = async (
  request: {
    clientId: string;
    scope: string;
    layer: string;
    clientName?: string;
    dangerZoneRequest?: boolean;
    environment?: string;
  },
  setToken: (value: string) => void,
  msalContext: {
    instance: IPublicClientApplication;
    account: AccountInfo;
  }
) => {
  setToken("Requesting token...");

  const accessToken = await acquireAccessTokenInteractive(
    msalContext.instance,
    msalContext.account
  );

  try {
    const { data: response } = await axios.post<TokenResponse>(
      process.env.REACT_APP_FUNCTION_APP_URL!,
      {
        clientId: request.clientId,
        scope: request.scope,
        idp: idpByLayer[request.layer] ?? request.layer,
        ...(request.dangerZoneRequest && {
          clientName: request.clientName,
          DangerZoneRequest: true,
          environment: request.environment,
        }),
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    setToken(response.accessToken);

    insertUrlParam("client", request.clientId);
    insertUrlParam("scope", request.scope);
    insertUrlParam("layer", request.layer);
  } catch (error) {
    if (error instanceof AxiosError) {
      const errorMessage = (() => {
        switch (error.response?.status) {
          case 400:
            return `Bad request: ${error.response?.data}`;
          case 403:
            return "You don't have permission to access this API";
          case 404:
            return `Could not find a valid credentials for the client: ${request.clientId}`;
          default:
            return `Error fetching token: ${error.message}`;
        }
      })();

      setToken(errorMessage);
      console.error(error.response?.data);
    } else {
      setToken("Error fetching token");
      console.error(error);
    }
  }
};
